module.exports = __webpack_public_path__ + "static/media/imgop_caseStudies.da303968.png";